import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import {
  Dot,
  Stack,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  TimelineSeparator,
  Typography,
} from '@lyearn/ui';
import { getDateString } from '@/helper/getDateString';

import VersionTimelineDot from './renderers';
import { timelineItemStyles } from './styles';
import { TimelineItemProps } from './types';

const HistoryTimelineItem: React.FC<TimelineItemProps> = (props) => {
  const { versionNumber, note, type, userName, createdAt, isFirstItem, isLastItem } = props;
  const { t } = useTranslation('Common');

  return (
    <TimelineItem className={timelineItemStyles(isLastItem)}>
      <TimelineSeparator className="me-20">
        <TimelineConnector
          className={cn(
            'absolute border-border bg-transparent border-s',
            isFirstItem ? 'top-16 bottom-0' : 'top-0',
            isLastItem ? 'h-16' : 'h-full',
          )}
        />
        <VersionTimelineDot isFirstItem={isFirstItem} type={type} versionNumber={versionNumber} />
      </TimelineSeparator>
      <TimelineContent className="mt-6 p-0">
        <Stack className="flex flex-1" direction="col">
          <Typography color="text-text-paragraph" numberOfLines={2} variant="body-short-01">
            {note}
          </Typography>
          <Typography
            className="mt-4 flex items-center"
            color="text-text-secondary"
            variant="body-short-02">
            {userName}
            <Dot />
            {getDateString(t, createdAt)}
          </Typography>
        </Stack>
      </TimelineContent>
    </TimelineItem>
  );
};

export default HistoryTimelineItem;
